module.exports = __webpack_public_path__ + "img/handshake-heart-gray.e43f83e1.svg";